/* The kit's 35 icons (gympe-app-design/icons) as a single component.
   24×24 viewBox, stroke=currentColor, width 1.6. Do not add another icon library. */

const PATHS = {
  home: 'M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-4v-6H9v6H5a1 1 0 0 1-1-1z',
  chart: 'M4 19h16M7 15l3.5-4.5 3 2.5L18 7',
  book: 'M8 3v3M16 3v3M4 9h16M5 6h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zM12 12v5M9.5 14.5h5',
  qr: 'M4 8V5a1 1 0 0 1 1-1h3M16 4h3a1 1 0 0 1 1 1v3M20 16v3a1 1 0 0 1-1 1h-3M8 20H5a1 1 0 0 1-1-1v-3M8 12h8',
  user: 'M12 11a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM5 20c.8-3.4 3.6-5.5 7-5.5s6.2 2.1 7 5.5',
  bell: 'M6.5 10a5.5 5.5 0 0 1 11 0c0 4 1.5 5.5 1.5 5.5H5S6.5 14 6.5 10zM10 18.5a2 2 0 0 0 4 0',
  right: 'M9 5l7 7-7 7',
  left: 'M15 5l-7 7 7 7',
  up: 'M12 19V5M6 11l6-6 6 6',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  plus: 'M12 5v14M5 12h14',
  minus: 'M5 12h14',
  flame: 'M12 21c3.3 0 5.5-2.2 5.5-5.2 0-3.7-3.7-5.3-3.7-8.8 0 0-2.4 1.2-2.4 3.7 0 1.6 1 2.4 1 3.6 0 1-.7 1.8-1.7 1.8s-1.7-.9-1.7-2.2c0-.6.1-1 .1-1S6.5 12.4 6.5 15.8C6.5 18.8 8.7 21 12 21z',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14zM16.5 16.5L21 21',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7.5V12l3 2',
  pin: 'M12 21s6.5-6 6.5-10.5a6.5 6.5 0 1 0-13 0C5.5 15 12 21 12 21zM12 13a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  card: 'M3.5 7.5h17a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-17a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1zM2.5 11.5h19M6 15.5h3',
  shield: 'M12 3.5l7 2.5v5.5c0 4.5-3.2 7.5-7 9-3.8-1.5-7-4.5-7-9V6z',
  out: 'M15 8V5.5a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V16M12 12h8M17 9l3 3-3 3',
  trash: 'M4.5 7h15M9 7V4.5h6V7M6.5 7l1 13h9l1-13M10 11v5.5M14 11v5.5',
  edit: 'M4 20h4L20 8l-4-4L4 16zM15 5l4 4',
  x: 'M6 6l12 12M18 6L6 18',
  medal: 'M12 15a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zM8 14l-2.5 7 3.5-2 3 2 3-2 3.5 2L16 14',
  spark: 'M12 3l1.6 5.2L19 10l-5.4 1.8L12 17l-1.6-5.2L5 10l5.4-1.8zM18 17l.8 2.2L21 20l-2.2.8L18 23l-.8-2.2L15 20l2.2-.8z',
  drop: 'M12 3.5S6 10 6 14a6 6 0 0 0 12 0c0-4-6-10.5-6-10.5z',
  leaf: 'M20 4S8 4 6 12c-1.2 4.8 1.2 8 1.2 8M8 16c6 0 10-3.5 11-9',
  dumbbell: 'M3 9v6M6 7v10M6 12h12M18 7v10M21 9v6',
  heart: 'M12 20s-7-4.3-7-9a4 4 0 0 1 7-2.6A4 4 0 0 1 19 11c0 4.7-7 9-7 9z',
  moon: 'M20 14.5A8.5 8.5 0 1 1 9.5 4a6.8 6.8 0 0 0 10.5 10.5z',
  scale: 'M4.5 8.5h15l1.5 11a1 1 0 0 1-1 1.2H4a1 1 0 0 1-1-1.2zM8 12.5c1 2.5 7 2.5 8 0M12 4v4.5',
  sun: 'M12 6.5V4M12 20v-2.5M6.5 12H4M20 12h-2.5M7.8 7.8L6 6M18 18l-1.8-1.8M16.2 7.8L18 6M6 18l1.8-1.8M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  cal: 'M8 3v3M16 3v3M4 9h16M5 6h14a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z',
  sliders: 'M5 7h9M18 7h1M5 12h3M12 12h7M5 17h9M18 17h1M15 5v4M9 10v4M15 15v4',
  help: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.8 9.4A2.3 2.3 0 0 1 14 10.6c0 1.6-2 1.8-2 3.2M12 17.2v.2',
  gift: 'M4 10h16v9a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1zM3.5 6.5h17V10h-17zM12 6.5V20M12 6.5S10.5 3 8.5 4s.5 2.5 3.5 2.5 5.5-1.5 3.5-2.5S12 6.5 12 6.5z',
} as const;

export type IconName = keyof typeof PATHS;

export default function Icon({
  n,
  s = 20,
  c = 'currentColor',
  w = 1.6,
}: {
  n: IconName;
  s?: number;
  c?: string;
  w?: number;
}) {
  return (
    <svg width={s} height={s} viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth={w} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d={PATHS[n]} />
    </svg>
  );
}

/** Suggests an icon for a bookable slot from its type/name. */
export function slotIcon(bookableType: string, name = ''): IconName {
  const n = name.toLowerCase();
  if (bookableType === 'spa') return n.includes('massage') ? 'heart' : 'drop';
  if (bookableType === 'pt') return 'dumbbell';
  if (bookableType === 'consult') return 'spark';
  if (bookableType === 'facility') return 'medal';
  if (n.includes('yoga') || n.includes('pilates') || n.includes('stretch')) return 'leaf';
  if (n.includes('nidra') || n.includes('medita')) return 'moon';
  if (n.includes('cycle') || n.includes('cardio') || n.includes('hiit') || n.includes('metcon')) return 'flame';
  return 'dumbbell';
}

/** Suggests an icon for a metric from its category/name. */
export function metricIcon(category = '', name = ''): IconName {
  const c = category.toLowerCase();
  const n = name.toLowerCase();
  if (n.includes('weight') && !n.includes('lift')) return 'scale';
  if (n.includes('fat') || n.includes('water')) return 'drop';
  if (n.includes('sleep')) return 'moon';
  if (n.includes('heart') || n.includes('hr') || c.includes('cardio')) return 'heart';
  if (c.includes('body')) return 'scale';
  if (c.includes('recovery') || c.includes('wellness')) return 'moon';
  if (c.includes('flexibility')) return 'leaf';
  return 'dumbbell';
}
